import { render, staticRenderFns } from "./ContactDistributionsByContactProperty.vue?vue&type=template&id=1c8fad5c&scoped=true"
import script from "./ContactDistributionsByContactProperty.vue?vue&type=script&lang=js"
export * from "./ContactDistributionsByContactProperty.vue?vue&type=script&lang=js"
import style0 from "./ContactDistributionsByContactProperty.vue?vue&type=style&index=0&id=1c8fad5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8fad5c",
  null
  
)

export default component.exports